export const SupportedLanguage = {
  IT: 'it',
  EN: 'en'
} as const;

export type SupportedLanguage = (typeof SupportedLanguage)[keyof typeof SupportedLanguage];
